import Chip from '@mui/material/Chip';
import { statusCategory, type StatusCategory } from '../lib/status';

// Tonale Farb-Map pro Workflow-Phase. Werte gleich wie StatusBreakdown.
const COLOR: Record<StatusCategory, string> = {
  new:        '#9e9e9e',
  open:       '#90a4ae',
  refine:     '#7e57c2',
  backlog:    '#5e7186',
  ready:      '#5677a3',
  progress:   '#1976d2',
  review:     '#7b1fa2',
  integ:      '#00838f',
  'await-test':'#ef6c00',
  test:       '#f57c00',
  resolved:   '#388e3c',
  closed:     '#2e7d32',
  done:       '#43a047',
  aborted:    '#616161',
  rejected:   '#c62828',
};

type Props = { status?: string; size?: 'small' | 'medium' };

export function StatusChip({ status, size = 'small' }: Props) {
  if (!status) return null;
  const cat = statusCategory(status);
  const color = COLOR[cat];
  return (
    <Chip
      label={status}
      size={size}
      sx={{
        bgcolor: `${color}1f`,        // ~12% Alpha
        color,
        fontWeight: 600,
        borderRadius: 1,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
}
